import {
    GETMAPPINGROLELIST_SUCCESS,
    GETMAPPINGROLELIST_FAILED,
    RESET_GETMAPPINGROLELIST,
    LOADING_GETMAPPINGROLELIST,
    NETWORK_ERROR_GETMAPPINGROLELIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetMappingRoleList = () => {
    return { type: RESET_GETMAPPINGROLELIST };
};

const getMappingRoleList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMAPPINGROLELIST });
    await adminServices
        .post("getRoleMappingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getMappingRoleListsuccess(res.data));
                    break;
                default:
                    dispatch(getMappingRoleListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETMAPPINGROLELIST, payload: err });
        });
};
function getMappingRoleListsuccess(data) {
    return {
        type: GETMAPPINGROLELIST_SUCCESS,
        payload: data,
    };
}
function getMappingRoleListFailed(data) {
    return {
        type: GETMAPPINGROLELIST_FAILED,
        payload: data,
    };
}

export { resetGetMappingRoleList, getMappingRoleList };
